import { render, staticRenderFns } from "./TaxationCreateUpdate.vue?vue&type=template&id=09796d0e&"
import script from "./TaxationCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./TaxationCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports